import * as Subtract from "./public/Subtract.svg";

export const Img_logo = Subtract;

